import React from 'react';
import { Avatar, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText } from '@mui/material';
import NotificationComponents from './NotificationComponents';
import { AvatarImage } from '../../Dashboard/Table/AvatarGroups';
import {
    getNotificationAction,
    getNotificationTime,
    getUserAvatarDetails,
} from './notification-helper';
import moment from 'moment';
import UnReadIcon from '../../SvgIcons/UnReadIcon';
import { useNavigate } from 'react-router-dom';
import { setAddBlockerModal, setGenptReportModal, setReportModal } from '../../../redux/reducers/dashboard';
import { useDispatch } from 'react-redux';
import { useMarkNotificationAsRead } from '../../../hooks/notifications';
import Storage from '../../../utils/Storage';

const Notification = ({ notification, onClose, mainUrl = "" }) => {

    console.log("mainUrl", mainUrl)
    let NotificationComponent = NotificationComponents["DEFAULT"];
    if (NotificationComponents[notification?.type]) {
        NotificationComponent = NotificationComponents[notification?.type]
    }

    const markNotification = useMarkNotificationAsRead();
    const userAvatarDetails = getUserAvatarDetails(notification);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const isGenptDeferExpiringReadOnly =
        notification?.type === 'GENPT_DEFER_EXPIRING_TOMORROW' &&
        moment(notification?.deferred_finding_date).isSameOrBefore(moment(), 'day');

    const handleClick = async (isGlobalCompany) => {
        if (isGenptDeferExpiringReadOnly) {
            return;
        }
        if (!isGlobalCompany) {
            onClose();
            return;
        }
        const action = await getNotificationAction(notification, mainUrl);
        if (action?.type === "NAVIGATE") {
            navigate(action?.url);
        } else if (action?.type === "OPEN_MODAL" && action.modalType === "BLOCKER") {
            dispatch(setAddBlockerModal({
                open: true,
                id: action?.id,
                pentest_asset_id: action?.assetId
            }));
            if (action?.url) {
                navigate(action?.url);
            }            
        } else if (action?.type === "OPEN_MODAL" && action.modalType === "REPORT") {
            console.log("action", action)
            console.log("action.data", action.data)
            if(action.data.report_type == 'genpt_pdf_report'){
                dispatch(
                    setGenptReportModal({
                        open: true,
                        session_id: action?.data?.session_id
                    })
                );
            }else{
                dispatch(
                    setReportModal({
                        open: true,
                        pentest_asset_id: action?.assetId,
                        pentest_id: action?.pentestId,
                        report: action?.data
                    })
                );
            }
        }
        markNotification.mutateAsync(notification?.id)
        onClose();
    }

    const avatarImageSection = userAvatarDetails?.profile_picture === "APP_LOGO" ? (
        <Avatar src="/images/avatar.png" className="mt-2 !w-[59px] !h-[59px]" />
    ) : (     
        <AvatarImage user={userAvatarDetails} className="!bg-primary-800 mt-2 !w-[59px] !h-[59px]" />
    );

    const handleLinkDefaultAction = (event) => {
        event.stopPropagation();
        onClose();
    }

    const readSection = !notification?.seen_at ? ( 
        <>
            <div className="font-normal text-base text-primary-500">{getNotificationTime(notification?.created_at)}</div>
            <UnReadIcon className={"!text-white"} />
        </>
    ) : (
        <div className="font-normal text-base text-primary-500">{getNotificationTime(notification?.created_at)}</div>
    );

    const notificationCompanyId = notification?.company_details?.id;
    const notificationCompanyName = notification?.company_details?.company_name;
    const globalCompanyDetails = JSON.parse(Storage.decryptStorageData('company_id'));
    const isGlobalCompany = globalCompanyDetails?.id === notificationCompanyId;

    /**
     * `GENPT_SCHEDULE_DELETED` resolves to an empty action in `notification-helper.js`
     * (no navigate, no modal). Clicking it still marks-as-read, but we drop the
     * pointer-cursor affordance so the row doesn't visually claim it's navigable.
     * Mirror the `.notification-item.inactive` cursor override pattern in SCSS.
     */
    const isNoActionNotification =
        notification?.type === 'GENPT_SCHEDULE_DELETED' || isGenptDeferExpiringReadOnly;
    const secondaryActionCursorClass = isNoActionNotification
        ? '!cursor-default'
        : 'cursor-pointer';

    return (
        <ListItem onClick={() => handleClick(isGlobalCompany)}
            alignItems="flex-start"
            className={`notification-item !items-center ${isGlobalCompany ? "active" : "inactive"} ${isNoActionNotification ? "no-action" : ""}`}
        >
            <ListItemAvatar>
                {avatarImageSection}
            </ListItemAvatar>
            <ListItemText
                primary=""
                secondary={
                    <React.Fragment>
                        <NotificationComponent
                            notification={notification}
                            mainUrl={mainUrl}
                            onLinkClick={handleLinkDefaultAction} />
                        <div className={`notification-company-name ${isGlobalCompany ? "inactive" : "active"}`}>{notificationCompanyName}</div>
                        <div className={`notification-company-name ${isGlobalCompany ? "current-company" : "no-current-company"}`}>This notification belongs to a different company. Please select the correct company to view the details.</div>
                    </React.Fragment>
                }
                className="pl-4"
            />

            <ListItemSecondaryAction className={`!right-0 ${secondaryActionCursorClass}`}  onClick={() => handleClick()}>
                <div className="w-[50px] text-center">{readSection}</div>
            </ListItemSecondaryAction>

        </ListItem>
    )
}

export default Notification;